import { createSelector } from "reselect"
import { get, chain, isFinite, map, pickBy, set } from "lodash"
import moment from "moment"
import { getAllItems, getOrderedCategoryItems } from "./items"
import { getFavoriteFactors } from "modules/portfolio-root/selectors/portfolios"
import { getFirst, getCurrent, getFilteredFactorSensitivity } from "."
import { computeCategoryItems, computeCategoryItemsSubset, computeDisplayCategories, computeNonZerosKeys, computeOptions } from "helpers/analyze"
import { getCategories } from "selectors/factors"

function mapSensitivityData(items, datum, index) {
  return chain(items)
    .filter(({ field }) => isFinite(get(datum, field, null)))
    .reduce((data, { id, field }) => set(data, id, get(datum, field)), { date: moment(datum.date), index })
    .value()
}

export function computeData(items, sensitivity) {
  return chain(sensitivity)
    .map((datum, index) => mapSensitivityData(items, datum, index))
    .compact()
    .value()
}

export const getData = createSelector(
  [getAllItems, getFilteredFactorSensitivity],
  computeData,
)

const getNonZerosKeys = createSelector(
  [getData, getFavoriteFactors],
  computeNonZerosKeys,
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys],
  (data, keys) => map(data, item => pickBy(item, (item, key) => keys[key])),
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItemsSubset,
)

export const getCategoryItems = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItems,
)

export const getDisplayCategories = createSelector(
  [getAllItems, getNonZerosKeys],
  computeDisplayCategories,
)

export const getOptions = createSelector(
  [getCategories, getFirst, getCurrent, getDisplayCategories],
  computeOptions,
)
